/*
 * Copyright (c) 2025 Autire Technologies, LLC. All Rights Reserved.
 *
 * This product and related documentation is protected by copyright and
 * distributed under licenses restricting its use, copying, distribution and
 * decompilation. No part of this product or related documentation may be
 * reproduced in any form by any means without prior written authorization
 * from Autire Technologies, LLC and/or its licensors.
 */
//@ts-check
import { combineReducers } from 'redux';

import {
  aSideMenuFlag,
  reviewScreenFlag,
  isDashboardOn,
  isRiskAnalysisTab,
  selectedCPA,
  displayWinscpOtp,
} from './common.reducer';
import { planInfo } from './audit.reducer';
import loader from './loader.reducer';

import { userDetails, userAuthorizationDetails } from './account.reducer';

const rootReducer = combineReducers({
  loader,
  aSideMenuFlag,
  reviewScreenFlag,
  isDashboardOn,
  isRiskAnalysisTab,
  planInfo,
  selectedCPA,
  //User
  userDetails,
  userAuthorizationDetails,
  displayWinscpOtp,
});

export default rootReducer;
